import { queryOptions, useQuery } from '@tanstack/react-query';
import { useLocation } from 'react-router-dom';

import { apiClient } from '@cast/infrastructure-api';

const SCHEDULED_REBALANCING_SCHEDULES_QUERY_KEY =
  'scheduled-rebalancing-schedules';

export const getRebalancingSchedulesQueryKey = (isInSecurity?: boolean) =>
  [
    SCHEDULED_REBALANCING_SCHEDULES_QUERY_KEY,
    ...(isInSecurity !== undefined ? [isInSecurity] : []),
  ] as const;

export const getRebalancingSchedulesQueryOptions = ({
  isInSecurity,
}: {
  isInSecurity: boolean;
}) =>
  queryOptions({
    queryKey: getRebalancingSchedulesQueryKey(isInSecurity),
    queryFn: async () => {
      const { data } = await apiClient.scheduledRebalancing.listSchedules();
      return data?.schedules || null;
    },
  });

type UseRebalancingSchedulesQuery = { enabled?: boolean };

export const useRebalancingSchedulesQuery = ({
  enabled = true,
}: UseRebalancingSchedulesQuery = {}) => {
  // TODO (Justas): Prevent demo schedules from security page being displayed anywhere else.
  // This will not be needed once we have query generators, as we'll be able to pass params to queries via context dynamically, without manually editing them
  const location = useLocation();
  const isInSecurity = location.pathname.includes('/security');

  const { isLoading, data, error, refetch } = useQuery({
    ...getRebalancingSchedulesQueryOptions({ isInSecurity }),
    enabled,
  });

  return {
    isLoading,
    schedules: data || undefined,
    error,
    refetch,
  };
};
